import type { ApprovalItem, Expense, TimeEntry } from './types'

export const currentWeek = [
  { day: 'Mon', date: 'Sep 7', dateKey: '2026-09-07' },
  { day: 'Tue', date: 'Sep 8', dateKey: '2026-09-08' },
  { day: 'Wed', date: 'Sep 9', dateKey: '2026-09-09', today: true },
  { day: 'Thu', date: 'Sep 10', dateKey: '2026-09-10' },
  { day: 'Fri', date: 'Sep 11', dateKey: '2026-09-11' },
  { day: 'Sat', date: 'Sep 12', dateKey: '2026-09-12' },
  { day: 'Sun', date: 'Sep 13', dateKey: '2026-09-13' }
]

export const initialTimeEntries: TimeEntry[] = [
  { id: 'time-1', date: '2026-09-07', project: 'Helix Data Platform', chargeCode: 'ENG-110', hours: 7.5, note: 'API integration and stand-up' },
  { id: 'time-2', date: '2026-09-08', project: 'Helix Data Platform', chargeCode: 'ENG-110', hours: 8, note: 'Integration tests' },
  { id: 'time-3', date: '2026-09-09', project: 'Northstar Analytics', chargeCode: 'PM-240', hours: 4, note: 'Client discovery workshop' },
  { id: 'time-4', date: '2026-09-09', project: 'Internal Operations', chargeCode: 'ADM-100', hours: 3, note: 'Planning and mentoring' },
  { id: 'time-5', date: '2026-09-10', project: 'Northstar Analytics', chargeCode: 'ENG-210', hours: 7, note: 'Reporting workspace' },
  { id: 'time-6', date: '2026-09-11', project: 'Northstar Analytics', chargeCode: 'ENG-210', hours: 5, note: 'Dashboard QA' }
]

export const initialExpenses: Expense[] = [
  {
    id: 'exp-1084',
    merchant: 'Northwind Hotel',
    transactionDate: '2026-09-05',
    amount: 428.6,
    currency: 'USD',
    category: 'Lodging',
    project: 'Northstar Analytics',
    status: 'submitted',
    analysis: 'analysis_complete',
    receiptName: 'northwind-hotel.pdf'
  },
  {
    id: 'exp-1083',
    merchant: 'Metro Rail',
    transactionDate: '2026-09-04',
    amount: 36,
    currency: 'USD',
    category: 'Ground transportation',
    project: 'Northstar Analytics',
    status: 'approved',
    analysis: 'analysis_complete',
    receiptName: 'metro-rail.jpg'
  },
  {
    id: 'exp-1082',
    merchant: 'Aster Coffee',
    transactionDate: '2026-09-03',
    amount: 16.75,
    currency: 'USD',
    category: 'Meals',
    project: 'Helix Data Platform',
    status: 'returned',
    analysis: 'analysis_complete',
    receiptName: 'aster-coffee.jpg',
    flag: 'Business purpose needs clarification'
  }
]

export const initialApprovalItems: ApprovalItem[] = [
  {
    id: 'apr-401',
    kind: 'Timesheet',
    employee: 'Priya Shah',
    initials: 'PS',
    period: 'Sep 7 – Sep 13',
    submittedAt: 'Today, 9:24 AM',
    total: '40.0 hours',
    status: 'submitted',
    age: '2h',
    detail: 'Four projects, seven entries. No overlapping time detected.'
  },
  {
    id: 'apr-400',
    kind: 'Expense',
    employee: 'Marcus Chen',
    initials: 'MC',
    period: 'Sep 5',
    submittedAt: 'Yesterday, 4:38 PM',
    total: '$612.40',
    status: 'submitted',
    age: '1d',
    flags: ['Amount differs from receipt by $8.00', 'Policy review'],
    detail: 'Travel expense for the Northstar customer workshop. Receipt OCR confidence: 96%.'
  },
  {
    id: 'apr-399',
    kind: 'Expense',
    employee: 'Noah Williams',
    initials: 'NW',
    period: 'Sep 4',
    submittedAt: 'Yesterday, 11:15 AM',
    total: '$84.18',
    status: 'submitted',
    age: '1d',
    flags: ['Receipt analysis pending'],
    detail: 'Client meal with receipt securely uploaded. Analysis is currently processing.'
  },
  {
    id: 'apr-398',
    kind: 'Timesheet',
    employee: 'Elena Ortiz',
    initials: 'EO',
    period: 'Aug 31 – Sep 6',
    submittedAt: 'Sep 7, 3:04 PM',
    total: '37.5 hours',
    status: 'submitted',
    age: '2d',
    detail: 'Client delivery work across Helix and Northstar engagements.'
  }
]

export const projectOptions = ['Helix Data Platform', 'Northstar Analytics', 'Internal Operations']
export const chargeCodeOptions = ['ENG-110 · Engineering', 'ENG-210 · Delivery', 'PM-240 · Project management', 'ADM-100 · Administration']
export const categoryOptions = ['Travel', 'Lodging', 'Meals', 'Mileage', 'Office/Supplies', 'Client expense', 'Training', 'Other']
